import dayjs from 'dayjs'

/*
 * Date/time formatting for the Hey Nic chat, matching 3Nickels' rules:
 *   - Transcript date separators: "Today", "Yesterday", else "M/D/YY"
 *     (single-digit month/day, no leading zero; 2-digit year).
 *   - Per-message timestamps: "h:mm AM/PM" (12-hour, zero-padded minutes).
 *   - Sidebar timestamps: the date label + " | h:mm AM/PM".
 */

const toDay = value => (value ? dayjs(value) : null)

/** "Today" | "Yesterday" | "M/D/YY" for the given timestamp. */
export function formatDateLabel(value) {
  const day = toDay(value)
  if (!day || !day.isValid()) return ''

  const today = dayjs().startOf('day')
  const target = day.startOf('day')
  const diff = today.diff(target, 'day')

  if (diff === 0) return 'Today'
  if (diff === 1) return 'Yesterday'
  return day.format('M/D/YY')
}

/** "h:mm AM/PM" for a single message. */
export function formatTime(value) {
  const day = toDay(value)
  if (!day || !day.isValid()) return ''
  return day.format('h:mm A')
}

/** Sidebar timestamp: "Today | 3:24 PM", "3/4/25 | 9:01 AM", etc. */
export function formatChatTimestamp(value) {
  const label = formatDateLabel(value)
  const time = formatTime(value)
  if (!label || !time) return ''
  return `${label} | ${time}`
}

/**
 * Buckets messages into ordered [label, messages[]] groups by calendar day so
 * the transcript can render a centered date separator above each group.
 */
export function groupMessagesByDay(messages = []) {
  const groups = []
  let currentLabel = null

  messages.forEach(message => {
    const label = formatDateLabel(message.timestamp)
    if (label !== currentLabel) {
      currentLabel = label
      groups.push({ label, messages: [] })
    }
    groups[groups.length - 1].messages.push(message)
  })

  return groups
}
